import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarDay, faCalendarWeek } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import { lessonsContext } from "../providers/lessons.provider"
import SegmentedPill from "../atoms/SegmentedPill"

const OPTIONS = [
	{ value: "day", text: "Giorno" },
	{ value: "week", text: "Settimana" },
]

const DESCRIPTIONS = {
	day: "Le lezioni si aprono sul giorno",
	week: "Le lezioni si aprono sulla settimana",
}

const ICONS = { day: faCalendarDay, week: faCalendarWeek }

// Da dove si parte aprendo le lezioni. Dalla fascia in cima (sul computer, in
// fondo alla barra laterale) si passa comunque dall'una all'altra: qui si
// sceglie solo quale si trova per prima.
// Come il tema vale per questo telefono o questo computer.
function LessonsViewSelector() {
	const { defaultLessonsView, setDefaultLessonsView, setLessonsView } =
		useContext(lessonsContext)

	return (
		<>
			<Div d="flex" align="center" style={{ gap: "0.75rem" }}>
				<Div
					w="40px"
					h="40px"
					rounded="circle"
					bg={theme.colors.gray_light}
					d="flex"
					align="center"
					justify="center"
					style={{ flexShrink: 0 }}>
					<FontAwesomeIcon
						icon={ICONS[defaultLessonsView]}
						color={theme.colors.text_light}
					/>
				</Div>
				<Div>
					<Text textWeight="bold" textSize="subheader">
						Vista delle lezioni
					</Text>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{DESCRIPTIONS[defaultLessonsView]}
					</Text>
				</Div>
			</Div>

			<Div m={{ t: "0.75rem" }}>
				<SegmentedPill
					options={OPTIONS}
					selected={defaultLessonsView}
					onChange={view => {
						setDefaultLessonsView(view)
						// chi l'ha appena scelta se la aspetta andando alle lezioni
						setLessonsView(view)
					}}
				/>
			</Div>
		</>
	)
}

export default LessonsViewSelector
